/**
 * NotesField Component
 * Field for request notes
 */

import React from 'react';
import {
    FormControl,
    FormLabel,
    TextField,
    FormHelperText,
} from '@mui/material';
import { useI18n } from '@shared/i18n';
import styles from './NotesField.module.css';

/**
 * Props for NotesField component
 */
export interface NotesFieldProps {
    /** Current value of the notes field */
    value: string;
    /** Callback when notes change */
    onChange: (value: string) => void;
}

/**
 * NotesField component
 */
export function NotesField({
    value,
    onChange,
}: NotesFieldProps): React.ReactElement {
    const { t } = useI18n();
    return (
        <div
            className={styles.field}
            data-testid="notes-field"
        >
            <FormControl fullWidth>
                <FormLabel
                    id="notes-label"
                    className={styles.fieldLabel}
                >
                    {t('requests.form.notes.label')}
                </FormLabel>
                <TextField
                    value={value}
                    onChange={(e): void => onChange(e.target.value)}
                    variant="outlined"
                    size="small"
                    multiline
                    rows={4}
                    aria-labelledby="notes-label"
                    inputProps={{
                        'aria-describedby': 'notes-helper-text',
                    }}
                    data-testid="notes-textfield"
                />
                <FormHelperText id="notes-helper-text">
                    {t('requests.form.notes.helper')}
                </FormHelperText>
            </FormControl>
        </div>
    );
}

export default NotesField;
